import React from "react";
import { Navigate } from "react-router-dom";
import { PAGE_ROUTES } from "../../utils/constants";
import AppSecureStorage from "../../services/secureStorage";
import { getDefaultRoute } from "./defaultRoute";

const ProtectedRoute = ({ children, hasPermission }) => {
  const storage = new AppSecureStorage();
  const tokenExpiry = storage.get("tokenExpiry");
  const isAuthenticated =
    storage.get("token") && new Date() < new Date(tokenExpiry);
  if (!isAuthenticated) {
    return <Navigate to={PAGE_ROUTES.LOGIN} replace />;
  }
  if (!hasPermission) {
    return <Navigate to={getDefaultRoute()} replace />;
  }
  return children;
};

export default ProtectedRoute;
